import React from 'react';

import { cx } from '@emotion/css';

import styles from './TermsAndConditions.module.scss';
import { TermsAndConditionsView } from './TermsAndConditionsView';

export const TermsAndConditions = () => {
  return (
    <div className={styles.body}>
      <div className={cx(styles.root, styles.root_form)}>
        <section className={cx(styles.sec, styles.form_wrpr)}>
          <div className={cx(styles.container, styles.inner)}>
            <div className={styles.row}>
              <div className={cx(styles.heading_blk)}>
                <TermsAndConditionsView styles={styles} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
